var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-Color",
    className: "cls-1",
    d: "M22.91,13.33A1.09,1.09,0,0,1,24,14.42h0v8.49A1.09,1.09,0,0,1,22.91,24H14.42a1.09,1.09,0,0,1-1.09-1.09h0V14.42a1.09,1.09,0,0,1,1.09-1.09h8.49Zm-13.33,0a1.09,1.09,0,0,1,1.09,1.09h0v8.49A1.09,1.09,0,0,1,9.58,24H1.09A1.09,1.09,0,0,1,0,22.91H0V14.42a1.09,1.09,0,0,1,1.09-1.09H9.58Zm12.24,2.18h-6.3v6.31h6.3Zm-13.33,0H2.18v6.31H8.49ZM9.58,0a1.09,1.09,0,0,1,1.09,1.09h0V9.58a1.09,1.09,0,0,1-1.09,1.09H1.09A1.09,1.09,0,0,1,0,9.58H0V1.09A1.09,1.09,0,0,1,1.09,0H9.58ZM22.91,0A1.09,1.09,0,0,1,24,1.09h0V9.58a1.09,1.09,0,0,1-1.09,1.09H14.42a1.09,1.09,0,0,1-1.09-1.09h0V1.09A1.09,1.09,0,0,1,14.42,0h8.49ZM8.49,2.18H2.18V8.49H8.49Zm13.33,0h-6.3V8.49h6.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.2777951d57cdab94413be5376280fe25.svg";
export { ForwardRef as ReactComponent };